import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { usePictogram } from '../../common/utils/useIllustration';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps } from '../../common/utils/productCardProps';
import { SIMPLE_VISA } from '../../products';
import SimpleVisaContent from '../common/SimpleVisaContent';
import { useSimpleVisaCardSelection, useSimpleVisaPrice } from '../common/hooks';
import SmallCardReadMore from '../../common/components/small-card-layout/SmallCardReadMore';
import { smallCardGrid } from '../../common/components/small-card-layout/SmallCardLayout';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = SIMPLE_VISA;
const texts = {
  description: 'simpleVisaAbstractSmallCard',
  readMoreContent: 'simpleVisaReadMoreModalContent',
  title: 'simpleVisaTitle',
  noVisaInfo: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Text',
  visaInfoHeader: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Header',
  nationalityPlaceholder: 'Products.SimpleVisa.Travelers.Nationality.Placeholder',
  nationalityLabel: 'Products.SimpleVisa.Travelers.Nationality.Label'
};
const SmallSimpleVisa = _ref => {
  let {
    className,
    form,
    order,
    cardSelection,
    contactEmail,
    hasAnySelected,
    priceRaw,
    selectProduct,
    selectAllTravelers,
    updateTotalPrice,
    travelers,
    selectTraveler,
    isSelected,
    productPosition,
    layoutType
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const translation = getTranslatedTexts(texts, t);
  const rootElement = useRef(null);
  const {
    description,
    readMoreContent,
    title
  } = translation;
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const pictogramUrl = usePictogram(PRODUCT_NAME);
  useSimpleVisaPrice(updateTotalPrice, priceRaw);
  const [isOpen] = useSimpleVisaCardSelection(hasAnySelected, cardSelection, selectProduct, selectAllTravelers, travelers);
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    price,
    priceLabel,
    priceSuffix
  } = getPriceProps(t, isSelected, {
    ...product,
    priceRaw
  });
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    noVisaInfo: translation.noVisaInfo,
    visaInfoHeader: translation.visaInfoHeader,
    nationalityPlaceholder: translation.nationalityPlaceholder,
    nationalityLabel: translation.nationalityLabel,
    selectTraveler
  };
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    description,
    extraProps,
    className,
    form,
    illustrationUrl: pictogramUrl,
    layoutType,
    priceRaw,
    price,
    priceLabel,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    readMoreButtonLabel,
    readMoreContent,
    title,
    travelers: order.travelers,
    shouldDisplayUpsell: false
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    customGrid: smallCardGrid,
    productData: productData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      override: true,
      children: /*#__PURE__*/_jsx(SmallCardReadMore, {})
    }), /*#__PURE__*/_jsx(SimpleVisaContent, {
      contactEmail: contactEmail,
      isOpen: isOpen,
      productName: PRODUCT_NAME,
      selectAllTravelers: () => selectAllTravelers(travelers, Boolean(cardSelection)),
      travelers: travelers
    })]
  });
};
export default SmallSimpleVisa;
//# sourceMappingURL=SmallSimpleVisa.js.map